





































































































































import { ErrorManager } from '@/models/error';
import { IQuoteTermItem, Quote } from '@/models/quote';
import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ErrorAlert from '../common/ErrorAlert.vue';
import QuoteTemplateNoteTooltipIcon from './templates/common/QuoteTemplateNoteTooltipIcon.vue';

export default Vue.extend({
  name: 'QuoteSummaryTermList',

  components: { ErrorAlert, QuoteTemplateNoteTooltipIcon },

  props: {
    quote: { type: Object as PropType<Quote> }
  },

  data() {
    return {
      loading: false,
      errorMessage: '',
      detailErrorMessage: ''
    };
  },

  computed: {
    ...mapGetters({
      getQuoteTermTemplateById: 'quoteTemplate/getQuoteTermTemplateById'
    })
  },

  mounted() {
    this.loading = true;
    this.fetchQuoteTermTemplates({
      organization: this.quote.organization
    })
      .catch(error => {
        if (error.response) {
          if (error.response.data.detail) {
            this.detailErrorMessage = error.response.data.detail;
            // if the organization is incorrect then a error is returned with that key
          } else if (error.response.data.organization) {
            this.detailErrorMessage = error.response.data.organization;
          }
        }
        this.errorMessage = ErrorManager.extractApiError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    ...mapActions({
      fetchQuoteTermTemplates: 'quoteTemplate/fetchQuoteTermTemplates'
    }),

    termItemTemplateNote(termItem: IQuoteTermItem) {
      const template = this.getQuoteTermTemplateById(termItem.template);
      let note = '';
      if (template) {
        note = template.note;
      }
      return note;
    },

    clearAllErrors() {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    }
  }
});
